export default __webpack_public_path__ + "static/scribble-1bffabe715af85453290d0854907b2c4.svg";